import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useService } from '@hooks';
import { electrificationWizardService, notificationService, simulationService, SimulationTask } from '@services';
import { RxUtils, Tr } from '@utils';
import { Button, Stack } from '@mui/material';
import { PortalPageTitle } from '@components/portal/common';
import { WizardVehicleList } from '@components/portal/wizard';

const paddingX = 9;
type Entity = SimulationTask;

export const ElectrificationSelectVehicles: FC = () => {
	const { t } = useTranslation('portal');
	const navigate = useNavigate();
	const [searchText, setSearchText] = useState('');
	const { data: simulationTasks = [] } = useService(() => simulationService.getLatestSimulationTasks());
	const [searchResult, setSearchResult] = useState<Entity[]>([]);
	const [selectedEntities, setSelectedEntities] = useState<Entity[]>([]);
	const entities = searchText ? searchResult : simulationTasks;

	const onNextButtonClicked = () => {
		const taskIds = selectedEntities.map(({ id }) => id);
		RxUtils.promisify(electrificationWizardService.create(taskIds), () => {
			notificationService.sendSuccess(t('wizard.create-success'));
			navigate('../processing');
		});
	};

	// useEffect(() => {
	// 	if (searchText) {
	// 		RxUtils.promisify(organizationService.search(searchText), setSearchResult);
	// 	} else {
	// 		setSearchResult([]);
	// 	}
	// }, [searchText]);

	return Array.isArray(simulationTasks) && simulationTasks.length ? (
		<Stack direction="column" spacing={3} sx={{ height: 1.0, maxHeight: 1.0, paddingY: 5 }}>
			<PortalPageTitle
				paddingX={4}
				sx={{ paddingRight: paddingX }}
				title={<Tr.Portal path="wizard.vehicle-selection.title" />}
				subtitle={<Tr.Portal path="wizard.vehicle-selection.subtitle" />}
				onBackButtonClick={() => navigate('..')}
				displaySearchbox
				searchboxProps={{
					testId: 'electrification-wizard-search-box',
					placeholder: t('wizard.vehicle-selection.search-placeholder'),
					searchText,
					onSearchTextChange: setSearchText
				}}
			/>
			<WizardVehicleList
				showResultCount={!!searchText}
				paddingX={paddingX}
				entities={entities}
				selected={selectedEntities}
				onSelectChange={setSelectedEntities}
			/>

			<Stack direction="row" spacing={3} justifyContent="center" sx={{ paddingX }}>
				<Button
					data-testid="electrification-wizard-manual-selection-next-button"
					variant="contained"
					color="primary"
					disabled={!selectedEntities.length}
					sx={{ textTransform: 'uppercase' }}
					onClick={onNextButtonClicked}
				>
					<Tr.Portal path="next" />
				</Button>
			</Stack>
		</Stack>
	) : null;
};
